
  import { computed, defineComponent, unref } from 'vue';
  import { useState } from 'vuex-composition-helpers';
  import CheckBoxInputList from '@fr/vue/components/inputs/CheckBoxInputList.vue';
  import Dropdown from '@ve/components/dropdown/desktop/Dropdown.vue';
  import { type MapForFiltersState } from '@ve/components/hotel/filters/common/store/types';
  import CheckBoxInput from '@ve/components/inputs/CheckBoxInput.vue';
  import { canonicalOperatorId } from '@entities/operator';
    import useOperatorsFilterHotel from '../common/useOperatorsFilterHotel';

  const filtersMappingStoreName = 'mapForFilters';
  export default defineComponent({
    name: 'OperatorsFilterHotel',
    components: {
      Dropdown,
      CheckBoxInputList,
      CheckBoxInput,
    },
    setup(props, { emit }) {
      const { operators } = useState<MapForFiltersState>(filtersMappingStoreName, ['operators']);

      const selectedOperators = computed({
        get: () => [...new Set(unref(operators).map((id) => canonicalOperatorId(id)))],
        set: (value) => {
          emit('operators-filter-changed', value);
        },
      });

      return {
        ...useOperatorsFilterHotel({ selectedOperators }),
        selectedOperators,
      };
    },
  });
